module.exports = __webpack_public_path__ + "static/media/HAUX_MAIS_VIDA_CLIENTES_2.8fd2f007.pdf";